import React, { useState, useEffect } from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import { Helmet } from "react-helmet"
import "../styles/new-space.scss"
import SEOHeader from "../components/seo-header"
import SimpleMap from "../components/simplemap"
import scrollTo from "gatsby-plugin-smoothscroll"
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"
import EnquiryForm from "../components/enquiry"
import NearBy from "../components/nearby"
import VizSensor from "react-visibility-sensor"
import moment from "moment"
import { nodeName } from "jquery"
import RelatedSpaces from "../components/related-spaces"
import AboutLocality from "../components/AboutLocality"
const MeetingSpaceNew = props => {
  const [currentTab, setcurrentTab] = useState("overview")
  const [scrollPosition, setPosition] = useState({ scrollX: 0, scrollY: 0 })
  const [showPhotos, setshowPhotos] = useState(false)
  const [reviewTab, setReviewTab] = useState("GoFloaters")
  const [FAQ, setFAQ] = useState(0)
  const [testimonialsToShow, setTestimonialsToShow] = useState([])

  //Create a testimonial array of 10 sample testimonials
  const Testimonials = [
    {
      name: "Anita Anand",
      comment:
        "I was looking for a flexible and comfortable workspace that met my requirements, and GoFloaters turned out to be the perfect solution.",
    },
    {
      name: "Puneet Dhiliwal",
      comment:
        "Seamless experience with GoFloaters in finalising venue for our business meeting and would like to specially appreciate Ms. Prerana for such smooth handling of our request. Professional Venue Selection and I will 100% recommend them!",
    },
    {
      name: "Ranjini Nair",
      comment:
        "Very easy to find co-working space or meeting rooms whichever city you need. I love the way their team responds and work hand in hand to take good care of their clients and customers.",
    },
    {
      name: "Shubham Wadkar",
      comment:
        "Excellent service! We truly appreciate your efficiency in arranging meeting spaces on short notice. The process was seamless, and everything was well-organized. Thank you for your professionalism and prompt support!",
    },
    {
      name: "Rajesh S",
      comment:
        "I was impressed with the variety of locations and the professional environment. GoFloaters made it easy for me to find a workspace that fit my needs.",
    },
    {
      name: "Raheela",
      comment:
        "I have been using GoFloaters since a while now, and I've always had a very smooth and seamless experience with the same.",
    },
    {
      name: "Pankaj Kumar",
      comment:
        "Recently attended a meeting at GoFloaters, and I was thoroughly impressed with the venue. The atmosphere was welcoming. The staff was attentive and ensured everything ran smoothly.",
    },
    {
      name: "Rajesh S",
      comment:
        "I was impressed with the variety of locations and the professional environment. GoFloaters made it easy for me to find a workspace that fit my needs.",
    },
    {
      name: "Pallavi Joshi",
      comment:
        "The booking process was seamless, and the support team was incredibly helpful. GoFloaters has truly transformed the way I work.",
    },
  ]

  useEffect(() => {
    function updatePosition() {
      setPosition({ scrollX: window.scrollX, scrollY: window.scrollY })
    }

    window.addEventListener("scroll", updatePosition)
    updatePosition()
    //Create a set of random 3 testimonials from the above
    const randomTestimonials = Testimonials.sort(
      () => 0.5 - Math.random()
    ).slice(0, 3)
    setTestimonialsToShow(randomTestimonials)
    return () => window.removeEventListener("scroll", updatePosition)
  }, [])
  // console.log(scrollPosition)
  const post = props.data.listings
  //const center = { lat: post.location[0], lng: post.location[1] }
  var activeClass = ""

  const Photos = post.photos?.map((photo, index) => (
    <div className="CoworkingimageBox">
      <img
        src={photo?.replace(
          "https://firebasestorage.googleapis.com/v0/b/gofloaters.appspot.com/o",
          "https://cdn.app.gofloaters.com"
        )}
        className="d-block w-100 img-responsive"
        alt={post.spaceGFName + " " + post.spaceDisplayName}
      ></img>
    </div>
  ))

  const Reviews = post.spaceFeedback
    ? post.spaceFeedback
        .filter(review => review.commentForSpaces) // Filter out empty comments
        .map((review, index) => (
          <div className="reviewBox" key={index}>
            <p>{review.commentForSpaces.slice(0, 50)} ...</p>
          </div>
        ))
    : null

  const Photos2 = post.photos.map((photo, index) => (
    <div className="col-md-9">
      <img
        src={photo?.replace(
          "https://firebasestorage.googleapis.com/v0/b/gofloaters.appspot.com/o",
          "https://cdn.app.gofloaters.com"
        )}
        className="img-responsive"
        alt={post.spaceGFName + " " + post.spaceDisplayName}
      ></img>
    </div>
  ))

  const TimeFormat = time => {
    const t = new Date(time)
    const formatted = moment(t).format("MMMM d, YYYY")
    return formatted
  }

  const ratingText = rating => {
    if (rating > 4.5) {
      return "Very Good"
    } else if (rating >= 3.5 && rating <= 4.5) {
      return "Good"
    } else if (rating >= 2.5 && rating <= 3.5) {
      return "Average"
    } else if (rating < 2.5) {
      return "Below Average"
    }
  }

  const spaceFeedbackComp = post.spaceFeedback
    ?.sort((a, b) => (a.feedbackDate < b.feedbackDate ? 1 : -1))
    .map(dataDrop => {
      if (dataDrop.customerName) {
        return (
          <div className="ratingCard">
            <div className="row">
              <div className="col-md-12">
                <p className="customerName">{dataDrop.customerName}</p>
              </div>
              <div className="col-md-12">
                <p>{dataDrop.commentForSpaces}</p>
              </div>
              <div className="col-md-9 col-6">
                <p>
                  <div>
                    <span
                      class={
                        "stars-container stars-" +
                        Number(20) * Number(dataDrop.rating)
                      }
                    >
                      ★★★★★
                    </span>
                  </div>
                </p>
              </div>
              <div className="col-md-3 col-6 text-right">
                <p style={{ fontSize: "12px" }}>
                  {TimeFormat(dataDrop.feedbackDate)}
                </p>
              </div>
            </div>
          </div>
        )
      }
    })
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }

  let SpaceSuitedFor = ""
  if (post.purposesList) {
    SpaceSuitedFor = post.purposesList.map((purpose, index) => (
      <span className="SpaceSuited" key={index}>
        {purpose}
      </span>
    ))
  }

  let operationTime = post.operationTime

  if (post.operationTime !== "") {
    operationTime = post.operationTime
      .split(", ")
      .map((operationTime, index) => (
        <div className="col-md-4  ">
          <div className="OperationTime row aligner" key={index}>
            <div className="col-2 text-center">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="1em"
                viewBox="0 0 512 512"
              >
                {" "}
                <path d="M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
              </svg>{" "}
            </div>
            <div className="col-10">
              <p className="OperationTimeText">
                <span>{operationTime.split(":")[0]}</span>
                <br></br>
                {operationTime.split(" : ")[1]}
              </p>
            </div>
          </div>
        </div>
      ))
  }

  var Title = ""
  if (post.spaceType === "Cafe") {
    Title = post.spaceDisplayName + " - " + post.spaceAddress
  } else {
    Title =
      post.spaceGFName +
      " - " +
      post.OriginalName +
      " - " +
      post.spaceDisplayName +
      " | Meeting Space near " +
      post.spaceAddress +
      ", "
  }
  function tConv24(time24) {
    var ts = time24
    var H = +ts.substr(0, 2)
    var h = H % 12 || 12
    h = h < 10 ? "0" + h : h // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? " AM" : " PM"
    ts = h + ts.substr(2, 3) + ampm
    return ts
  }
  var today = new Date()
  var day = today.getDay()

  var daylist = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ]
  var todayDay = daylist[day]
  function timeCal(todayDay) {
    switch (todayDay) {
      case "Monday":
        if (post.monday.holiday) return "Holiday"
        else {
          return tConv24(post.monday.from) + " - " + tConv24(post.monday.to)
        }
      case "Tuesday":
        if (post.tuesday.holiday) return "Holiday"
        else {
          return tConv24(post.tuesday.from) + " - " + tConv24(post.tuesday.to)
        }
      case "Wednesday":
        if (post.wednesday.holiday) return "Holiday"
        else {
          return (
            tConv24(post.wednesday.from) + " - " + tConv24(post.wednesday.to)
          )
        }
      case "Thursday":
        if (post.thursday.holiday) return "Holiday"
        else {
          return tConv24(post.thursday.from) + " - " + tConv24(post.thursday.to)
        }
      case "Friday":
        if (post.friday.holiday) return "Holiday"
        else {
          return tConv24(post.friday.from) + " - " + tConv24(post.friday.to)
        }
      case "Saturday":
        if (post.saturday.holiday) return "Holiday"
        else {
          return tConv24(post.saturday.from) + " - " + tConv24(post.saturday.to)
        }
      case "Sunday":
        if (post.sunday.holiday) return "Holiday"
        else {
          return tConv24(post.sunday.from) + " - " + tConv24(post.sunday.to)
        }
      default:
        return ""
    }
  }
  const filter = {
    geoLocation: post.geoLocation[0],
    slug: post.slug,
  }

  return (
    <div>
      <SEOHeader
        title={Title + "  " + post.spaceCity + " | GoFloaters"}
        description={Title + " : " + post.spaceDesc}
        socialURL={post.spaceImage}
        pinterest="true"
      ></SEOHeader>
      <Helmet>
        <script
          src="https://code.jquery.com/jquery-3.4.1.slim.min.js"
          integrity="sha384-J6qa4849blE2+poT4WnyKhv5vZF5SrPo0iEjwBvKU7imGFAV0wwj1yYfoRSJoZ+n"
          crossorigin="anonymous"
          defer
        ></script>
        <script
          src="https://cdn.jsdelivr.net/npm/popper.js@1.16.0/dist/umd/popper.min.js"
          integrity="sha384-Q6E9RHvbIyZFJoft+2mJbHaEWldlvI9IOYy5n3zV9zzTtmI3UksdQRVvoxMfooAo"
          crossorigin="anonymous"
          defer
        ></script>
        <script
          src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.min.js"
          integrity="sha384-wfSDF2E50Y2D1uUdj0O3uMBJnjuUD4Ih7YwaYd1iqfktj0Uod8GCExl3Og8ifwB6"
          crossorigin="anonymous"
          defer
        ></script>
        <script type="application/ld+json">{`{"@context":"http://schema.org","@type":"LocalBusiness","@id":"${
          post.slug
        }","name":"${
          post.spaceDisplayName + " - " + post.OriginalName
        }","telephone":"+91 7338 7308 00","url":"https://gofloaters.com/meeting-space/${
          post.slug
        }/","address":{"@type":"PostalAddress","addressCountry":"IN","streetAddress":"${
          post.spaceAddress
        }","addressLocality":"${
          post.spaceCity
        }","addressRegion":"IN"},"geo":{"@type":"GeoCoordinates","latitude":"${
          post.geoLocation[0]
        }","longitude":"${
          post.geoLocation[1]
        }"},"email":"support@gofloaters.com","image":{"@type":"ImageObject","url":"${
          post.photos[0]
        }"}}`}</script>
      </Helmet>
      <Layout type="meetingSpace">
        {scrollPosition.scrollY > 800 ? (
          <div className="topBarCoworking">
            <div className="container">
              <div className="row">
                <div className="col-md-8 DesktopOnly">
                  <br></br>
                  <br></br>
                  <ul className="coworkingLinks">
                    <li className={currentTab === "overview" ? "active" : ""}>
                      <a
                        onClick={() => {
                          scrollTo("#overview")
                          setcurrentTab("overview")
                        }}
                      >
                        Overview
                      </a>
                    </li>
                    <li className={currentTab === "amenities" ? "active" : ""}>
                      <a
                        onClick={() => {
                          scrollTo("#amenities")
                          setcurrentTab("amenities")
                        }}
                      >
                        Amenities
                      </a>
                    </li>
                    <li className={currentTab === "opening" ? "active" : ""}>
                      <a
                        onClick={() => {
                          scrollTo("#opening")
                          setcurrentTab("opening")
                        }}
                      >
                        Opening Hours
                      </a>
                    </li>
                    <li className={currentTab === "location" ? "active" : ""}>
                      <a
                        onClick={() => {
                          scrollTo("#location")
                          setcurrentTab("location")
                        }}
                      >
                        Location
                      </a>
                    </li>
                    <li className={currentTab === "rating" ? "active" : ""}>
                      <a
                        onClick={() => {
                          scrollTo("#rating")
                          setcurrentTab("rating")
                        }}
                      >
                        Reviews
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4 DesktopOnly">
                  {post.spaceType !== "Cafe" ? (
                    <h5 style={{ margin: "0", fontWeight: "bold" }}>
                      <br></br>
                      {post.OriginalName}
                    </h5>
                  ) : (
                    <h5 style={{ margin: "0", fontWeight: "bold" }}>
                      {post.spaceAddress}
                      <br></br>
                    </h5>
                  )}
                  {post.spaceType === "Cafe" ? (
                    <p>
                      {post.spaceDisplayName} in {post.spaceAddress},{" "}
                      {post.spaceCity}
                    </p>
                  ) : (
                    <p>
                      {post.spaceDisplayName} in {post.spaceAddress},{" "}
                      {post.spaceCity}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        <div
          itemscope
          itemtype="https://schema.org/LocalBusiness"
          className="container newspaceDetailContainer"
        >
          <div className="row">
            <div className="col-md-12 addressBar">
              <ol itemscope itemtype="https://schema.org/BreadcrumbList">
                <li
                  style={{ paddingLeft: "0" }}
                  itemprop="itemListElement"
                  itemscope
                  itemtype="https://schema.org/ListItem"
                >
                  <Link itemprop="item" to="/meeting-spaces/">
                    <span itemprop="name">Meeting Spaces</span>
                  </Link>
                  <meta itemprop="position" content="1" />
                </li>
                ›
                <li
                  itemprop="itemListElement"
                  itemscope
                  itemtype="https://schema.org/ListItem"
                >
                  <Link
                    to={
                      "/meeting-spaces/" +
                      post.spaceCity.toLowerCase().replace(" ", "-") +
                      "/all"
                    }
                    itemscope
                    itemtype="https://schema.org/WebPage"
                    itemprop="item"
                    itemid={
                      "/meeting-spaces/" +
                      post.spaceCity.toLowerCase().replace(" ", "-") +
                      "/all"
                    }
                  >
                    <span itemprop="name">{post.spaceCity}</span>
                  </Link>
                  <meta itemprop="position" content="2" />
                </li>
                ›
                <li
                  itemprop="itemListElement"
                  itemscope
                  itemtype="https://schema.org/ListItem"
                >
                  <span itemprop="name">
                    {post.spaceDisplayName} in {post.spaceAddress},{" "}
                    {post.spaceCity} ({post.spaceGFName})
                  </span>
                  <meta itemprop="position" content="3" />
                </li>
              </ol>
            </div>
          </div>
          <div className="row specialPadding">
            <div className="col-md-12">
              {post.spaceType === "Cafe" ? (
                <h1 className="coworkingTitle" itemprop="name">
                  {post.spaceDisplayName} in {post.spaceAddress},{" "}
                  {post.spaceCity}
                </h1>
              ) : (
                <h1 className="coworkingTitle" itemprop="name">
                  {post.spaceDisplayName} in {post.spaceAddress},{" "}
                  {post.spaceCity}
                </h1>
              )}
              {post.spaceType !== "Cafe" ? (
                <h2 className="coworkingLocationTitle">
                  <Link to={"/" + post.citySlug + "/" + post.buildingSlug}>
                    {post.OriginalName}
                  </Link>
                  <br></br>
                </h2>
              ) : (
                <h2 className="coworkingLocationTitle">
                  {post.spaceAddress}
                  <br></br>
                </h2>
              )}
            </div>
            {/* <div className="col-md-3 col-3 text-right">
              <div className="MobileOnly">
                <a
                  className="shareButton"
                  href={
                    "https://wa.me/?text=Hey,\n\n Checkout this nice place for us on GoFloaters https://www.gofloaters.com/meeting-spaces/" +
                    post.slug
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="1em"
                    viewBox="0 0 576 512"
                  >
                    <path d="M400 255.4V240 208c0-8.8-7.2-16-16-16H352 336 289.5c-50.9 0-93.9 33.5-108.3 79.6c-3.3-9.4-5.2-19.8-5.2-31.6c0-61.9 50.1-112 112-112h48 16 32c8.8 0 16-7.2 16-16V80 64.6L506 160 400 255.4zM336 240h16v48c0 17.7 14.3 32 32 32h3.7c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7V80H336 304 288c-88.4 0-160 71.6-160 160c0 60.4 34.6 99.1 63.9 120.9c5.9 4.4 11.5 8.1 16.7 11.2c4.4 2.7 8.5 4.9 11.9 6.6c3.4 1.7 6.2 3 8.2 3.9c2.2 1 4.6 1.4 7.1 1.4h2.5c9.8 0 17.8-8 17.8-17.8c0-7.8-5.3-14.7-11.6-19.5l0 0c-.4-.3-.7-.5-1.1-.8c-1.7-1.1-3.4-2.5-5-4.1c-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5c-2.6-6-4.3-13.3-4.3-22.4c0-36.1 29.3-65.5 65.5-65.5H304h32zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z" />
                  </svg>{" "}
                </a>
              </div>
              <div className="DesktopOnly">
                <a
                  className="shareButton"
                  href={
                    "https://wa.me/?text=Hey,\n\n Checkout this nice place for us on GoFloaters https://www.gofloaters.com/meeting-spaces/" +
                    post.slug
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="1em"
                    viewBox="0 0 576 512"
                  >
                    <path d="M400 255.4V240 208c0-8.8-7.2-16-16-16H352 336 289.5c-50.9 0-93.9 33.5-108.3 79.6c-3.3-9.4-5.2-19.8-5.2-31.6c0-61.9 50.1-112 112-112h48 16 32c8.8 0 16-7.2 16-16V80 64.6L506 160 400 255.4zM336 240h16v48c0 17.7 14.3 32 32 32h3.7c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7V80H336 304 288c-88.4 0-160 71.6-160 160c0 60.4 34.6 99.1 63.9 120.9c5.9 4.4 11.5 8.1 16.7 11.2c4.4 2.7 8.5 4.9 11.9 6.6c3.4 1.7 6.2 3 8.2 3.9c2.2 1 4.6 1.4 7.1 1.4h2.5c9.8 0 17.8-8 17.8-17.8c0-7.8-5.3-14.7-11.6-19.5l0 0c-.4-.3-.7-.5-1.1-.8c-1.7-1.1-3.4-2.5-5-4.1c-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5c-2.6-6-4.3-13.3-4.3-22.4c0-36.1 29.3-65.5 65.5-65.5H304h32zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z" />
                  </svg>{" "}
                  Share
                </a>
              </div>
            </div> */}
          </div>

          <div className="row ">
            {/* <div className="col-md-12 MobileOnly">
              <Carousel
                swipeable={true}
                draggable={true}
                showDots={true}
                responsive={responsive}
                ssr={true} // means to render carousel on server-side.
                autoPlay={false}
                autoPlaySpeed={3000}
                keyBoardControl={true}
                containerClassName="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                deviceType={props.deviceType}
                dotListClassName="custom-dot-list-style"
              >
                {Photos}
              </Carousel>
            </div> */}

            <div className="col-md-12  ">
              <div className="row">
                <div className="col-md-8">
                  {Photos ? (
                    <Carousel
                      swipeable={true}
                      draggable={true}
                      showDots={true}
                      responsive={responsive}
                      ssr={true} // means to render carousel on server-side.
                      autoPlay={false}
                      autoPlaySpeed={3000}
                      keyBoardControl={true}
                      containerClassName="carousel-container"
                      removeArrowOnDeviceType={["tablet", "mobile"]}
                      deviceType={props.deviceType}
                      dotListClassName="custom-dot-list-style"
                    >
                      {Photos}
                    </Carousel>
                  ) : (
                    ""
                  )}
                  {post.meetingRoomName ? (
                    <p style={{ fontSize: "18px", paddingTop: "5px" }}>
                      Room Name: <b>{post.meetingRoomName}</b>
                    </p>
                  ) : (
                    ""
                  )}
                  <div className="offerCardContainer">
                    <div className="offerCardContent">
                      Use code <span className="offerCardCode">FIRST10</span> to
                      save 10%
                    </div>
                  </div>
                  <div className="MobileOnly">
                    {post.avgRating ? (
                      <p>
                        <div
                          itemprop="aggregateRating"
                          itemscope
                          itemtype="https://schema.org/AggregateRating"
                          className="aggregateRating"
                        >
                          <span style={{ color: "#101010" }}>
                            {" "}
                            {post.avgRating}
                          </span>{" "}
                          <span
                            class={
                              "stars-container stars-" +
                              Number(20) * Number(post.avgRating)
                            }
                          >
                            ★★★★★
                          </span>
                          {"   "}
                          <br />
                          <a onClick={() => scrollTo("#rating")}>
                            See all{" "}
                            <span itemprop="reviewCount">
                              {Number(post.spaceFeedback.length) +
                                Number(post.googleReviewCount)}
                            </span>{" "}
                            review
                            {post.spaceFeedback.length > 1 ? "s" : ""}
                          </a>
                          <br />
                          <br />
                          <div className="reviewBoxOuter">
                            {Reviews.length > 0 ? (
                              <Carousel
                                swipeable={true}
                                draggable={true}
                                showDots={true}
                                responsive={responsive}
                                ssr={true} // means to render carousel on server-side.
                                autoPlay={false}
                                autoPlaySpeed={3000}
                                keyBoardControl={true}
                                containerClassName="carousel-container"
                                removeArrowOnDeviceType={["tablet", "mobile"]}
                                deviceType={props.deviceType}
                                dotListClassName="custom-dot-list-style"
                              >
                                {Reviews}
                              </Carousel>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <br />
                  {SpaceSuitedFor !== "" ? (
                    <div>
                      <h4>Space Best Suited for</h4>
                      <div style={{ paddingTop: "10px" }}>{SpaceSuitedFor}</div>
                    </div>
                  ) : (
                    ""
                  )}{" "}
                  <br />
                  <div>
                    <div className="row amenties">
                      <div className="col-md-12">
                        <h4 id="amenities">Amenities</h4>
                        <VizSensor
                          onChange={() => {
                            setcurrentTab("amenities")
                          }}
                        >
                          <p>Space info</p>
                        </VizSensor>
                      </div>
                      {post.Facility.search("Hi Speed WiFi") > 1 ? (
                        <div className="col-md-4 col-6">
                          <div className="row aligner">
                            <div className="col-3 text-center">
                              <img
                                src="https://assets.gofloaters.com/icons/svg/hi_speed_wifi.svg"
                                alt="Hi Speed WiFi"
                                style={{
                                  width: "45px",
                                  border: "1px solid #e0e0e0",
                                  padding: "10px 7px",
                                  borderRadius: "5px",
                                }}
                              ></img>
                            </div>
                            <div className="col-9">
                              <p>Hi Speed WiFi</p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {post.Facility.search("Power Backup") > 1 ? (
                        <div className="col-md-4 col-6">
                          <div className="row aligner">
                            <div className="col-3 text-center">
                              <img
                                src="https://assets.gofloaters.com/icons/svg/power_backup.svg"
                                alt="Power Backup"
                                style={{
                                  width: "45px",
                                  border: "1px solid #e0e0e0",
                                  padding: "10px 7px",
                                  borderRadius: "5px",
                                }}
                              ></img>
                            </div>
                            <div className="col-9">
                              <p>Power Backup</p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {post.Facility.search("WiFi Backup") > 1 ? (
                        <div className="col-md-4 col-6">
                          <div className="row aligner">
                            <div className="col-3 text-center">
                              <img
                                src="https://assets.gofloaters.com/icons/svg/wifi_backup.svg"
                                alt="WiFi Backup"
                                style={{
                                  width: "45px",
                                  border: "1px solid #e0e0e0",
                                  padding: "10px 7px",
                                  borderRadius: "5px",
                                }}
                              ></img>
                            </div>
                            <div className="col-9">
                              <p> WiFi Backup</p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {post.Facility.search("Projector") > 1 ? (
                        <div className="col-md-4 col-6">
                          <div className="row aligner">
                            <div className="col-3 text-center">
                              <img
                                src="https://assets.gofloaters.com/icons/svg/projectors.svg"
                                alt="Projector"
                                style={{
                                  width: "45px",
                                  border: "1px solid #e0e0e0",
                                  padding: "10px 7px",
                                  borderRadius: "5px",
                                }}
                              ></img>
                            </div>
                            <div className="col-9">
                              <p>Projector</p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {post.Facility.search("Television") > 1 ? (
                        <div className="col-md-4 col-6">
                          <div className="row aligner">
                            <div className="col-3 text-center">
                              <img
                                src="https://assets.gofloaters.com/icons/svg/television.svg"
                                alt="Television"
                                style={{
                                  width: "45px",
                                  border: "1px solid #e0e0e0",
                                  padding: "10px 7px",
                                  borderRadius: "5px",
                                }}
                              ></img>
                            </div>
                            <div className="col-9">
                              <p>Television</p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {post.Facility.search("Whiteboard") > 1 ? (
                        <div className="col-md-4 col-6">
                          <div className="row aligner">
                            <div className="col-3 text-center">
                              <img
                                src="https://assets.gofloaters.com/icons/svg/white_board.svg"
                                alt="Whiteboard"
                                style={{
                                  width: "45px",
                                  border: "1px solid #e0e0e0",
                                  padding: "10px 7px",
                                  borderRadius: "5px",
                                }}
                              ></img>
                            </div>
                            <div className="col-9">
                              <p>Whiteboard</p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>{" "}
                  <br></br>
                  <p>Building Info</p>{" "}
                  <div className="row amenties">
                    {post.Facility.search("AC") > 1 ? (
                      <div className="col-md-4 col-6">
                        <div className="row aligner">
                          <div className="col-3 text-center">
                            <img
                              src="https://assets.gofloaters.com/icons/svg/ac.svg"
                              alt="AC"
                              style={{
                                width: "45px",
                                border: "1px solid #e0e0e0",
                                padding: "10px 7px",
                                borderRadius: "5px",
                              }}
                            ></img>
                          </div>
                          <div className="col-9">
                            <p>AC</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {post.Facility.search("Metro Nearby") > 1 ? (
                      <div className="col-md-4 col-6">
                        <div className="row aligner">
                          <div className="col-3 text-center">
                            <img
                              src="https://assets.gofloaters.com/icons/svg/metro_nearby.svg"
                              alt="Metro Nearby"
                              style={{
                                width: "45px",
                                border: "1px solid #e0e0e0",
                                padding: "10px 7px",
                                borderRadius: "5px",
                              }}
                            ></img>
                          </div>
                          <div className="col-9">
                            <p>Metro Nearby</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {post.Facility.search("Free Parking") > 1 ? (
                      <div className="col-md-4 col-6">
                        <div className="row aligner">
                          <div className="col-3 text-center">
                            <img
                              src="https://assets.gofloaters.com/icons/svg/free_parking.svg"
                              alt="Free Parking"
                              style={{
                                width: "45px",
                                border: "1px solid #e0e0e0",
                                padding: "10px 7px",
                                borderRadius: "5px",
                              }}
                            ></img>
                          </div>
                          <div className="col-9">
                            <p>Free Parking</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {post.Facility.search("Rest Rooms") > 1 ? (
                      <div className="col-md-4 col-6">
                        <div className="row aligner">
                          <div className="col-3 text-center">
                            <img
                              src="https://assets.gofloaters.com/icons/svg/rest_rooms.svg"
                              alt="Rest Rooms"
                              style={{
                                width: "45px",
                                border: "1px solid #e0e0e0",
                                padding: "10px 7px",
                                borderRadius: "5px",
                              }}
                            ></img>
                          </div>
                          <div className="col-9">
                            <p>Rest Rooms</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {post.Facility.search("Coffee/Tea") > 1 ? (
                      <div className="col-md-4 col-6">
                        <div className="row aligner">
                          <div className="col-3 text-center">
                            <img
                              src="https://assets.gofloaters.com/icons/svg/coffee_tea.svg"
                              alt="Coffee/Tea"
                              style={{
                                width: "45px",
                                border: "1px solid #e0e0e0",
                                padding: "10px 7px",
                                borderRadius: "5px",
                              }}
                            ></img>
                          </div>
                          <div className="col-9">
                            <p>Coffee/Tea</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {post.Facility.search("Pantry") > 1 ? (
                      <div className="col-md-4 col-6">
                        <div className="row aligner">
                          <div className="col-3 text-center">
                            <img
                              src="https://assets.gofloaters.com/icons/svg/pantry.svg"
                              alt="Pantry"
                              style={{
                                width: "45px",
                                border: "1px solid #e0e0e0",
                                padding: "10px 7px",
                                borderRadius: "5px",
                              }}
                            ></img>
                          </div>
                          <div className="col-9">
                            <p>Pantry</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {post.Facility.search("Meeting Rooms") > 1 ? (
                      <div className="col-md-4 col-6">
                        <div className="row aligner">
                          <div className="col-3 text-center">
                            <img
                              src="https://assets.gofloaters.com/icons/svg/meeting_rooms.svg"
                              alt="Meeting Rooms"
                              style={{
                                width: "45px",
                                border: "1px solid #e0e0e0",
                                padding: "10px 7px",
                                borderRadius: "5px",
                              }}
                            ></img>
                          </div>
                          <div className="col-9">
                            <p>Meeting Rooms</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {post.Facility.search("Outside Food Allowed") > 1 ? (
                      <div className="col-md-4 col-6">
                        <div className="row aligner">
                          <div className="col-3 text-center">
                            <img
                              src="https://assets.gofloaters.com/icons/svg/outside_food_allowed.svg"
                              alt="Outside Food Allowed"
                              style={{
                                width: "45px",
                                border: "1px solid #e0e0e0",
                                padding: "10px 7px",
                                borderRadius: "5px",
                              }}
                            ></img>
                          </div>
                          <div className="col-9">
                            <p>Outside Food Allowed</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <br />
                  <div
                    style={{
                      padding: "10px 15px 20px",
                      // border: "1px solid #2193b0",
                      borderRadius: "5px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      backgroundImage:
                        "linear-gradient(to right, #f8f8f8, #f9f9f9)",
                    }}
                  >
                    <div className="row">
                      <div className="col-md-12">
                        <h4 id="amenities">GoFloaters Advantage</h4>
                      </div>
                      <div className="col-md-6 col-12">
                        <div className="row aligner paddingTriggerTwo">
                          <div className="col-md-3 col-3 text-center">
                            <img
                              src="https://assets.gofloaters.com/icons/svg/lower-price.svg"
                              style={{ width: "36px" }}
                            ></img>
                          </div>
                          <div className="col-md-9 col-9">
                            <h2
                              style={{ fontWeight: "bold", fontSize: "16px" }}
                            >
                              Lowest Price Guaranteed
                            </h2>
                            {/* <p>
                            You can trust us with our fair and dependable
                            prices.
                          </p> */}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-12">
                        <div className="row aligner paddingTriggerTwo">
                          <div className="col-md-3 col-3 text-center">
                            <img
                              src="https://assets.gofloaters.com/icons/svg/free-rescheduling.svg"
                              style={{ width: "36px" }}
                            ></img>
                          </div>
                          <div className="col-md-9 col-9">
                            <h2
                              style={{ fontWeight: "bold", fontSize: "16px" }}
                            >
                              Free Rescheduling
                            </h2>
                            {/* <p>
                            You can modify the date,time and other details of
                            your scheduled booking .
                          </p> */}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-12">
                        <div className="row aligner paddingTriggerTwo">
                          <div className="col-md-3 col-3 text-center">
                            <img
                              src="https://assets.gofloaters.com/icons/svg/free-cancellation.svg"
                              style={{ width: "36px" }}
                            ></img>
                          </div>
                          <div className="col-md-9 col-9">
                            <h2
                              style={{ fontWeight: "bold", fontSize: "16px" }}
                            >
                              Free Cancellation
                            </h2>
                            {/* <p>You can cancel booking upto 48 hours</p> */}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-12">
                        <div className="row aligner paddingTriggerTwo">
                          <div className="col-md-3 col-3 text-center">
                            <img
                              src="https://assets.gofloaters.com/icons/svg/instant-confirmations.png"
                              style={{ width: "36px" }}
                            ></img>
                          </div>
                          <div className="col-md-9 col-9">
                            <h2
                              style={{ fontWeight: "bold", fontSize: "17px" }}
                            >
                              Instant Confirmations
                            </h2>
                            {/* <p>You can cancel booking upto 48 hours</p> */}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-12">
                        <div className="row aligner paddingTriggerTwo">
                          <div className="col-md-3 col-3 text-center">
                            <img
                              src="https://assets.gofloaters.com/icons/svg/verified-listings.png"
                              style={{ width: "36px" }}
                            ></img>
                          </div>
                          <div className="col-md-9 col-9">
                            <h2
                              style={{ fontWeight: "bold", fontSize: "17px" }}
                            >
                              Verified listings
                            </h2>
                            {/* <p>You can cancel booking upto 48 hours</p> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    {post.exclusiveOffer ? (
                      <div>
                        <br></br>
                        <h4>Remarks</h4> <p>{post.exclusiveOffer}</p>
                      </div>
                    ) : (
                      <p> </p>
                    )}
                    <br></br>
                    <h4 id="opening">Opening Hours</h4>
                    <VizSensor
                      onChange={() => {
                        setcurrentTab("opening")
                      }}
                    >
                      <b>Today ({todayDay})</b>
                    </VizSensor>
                    <br />
                    {timeCal(todayDay)}
                    <br />
                    <br />
                    <div
                      className="row"
                      style={{
                        padding: "10px 5px",
                        margin: "0",
                        border: "1px solid #e0e0e0",
                        borderRadius: "5px",
                      }}
                    >
                      {operationTime}
                    </div>
                  </div>
                  <br></br>
                  <h4 id="locationMap">Location</h4>
                  <div>
                    <VizSensor
                      onChange={() => {
                        setcurrentTab("location")
                      }}
                    >
                      {post.geoLocation !== "" ? (
                        <SimpleMap
                          lat={post.geoLocation[0]}
                          lng={post.geoLocation[1]}
                        ></SimpleMap>
                      ) : (
                        "<p></p>"
                      )}
                    </VizSensor>
                  </div>
                  <br></br>{" "}
                  {post.nearBy.length > 1 ? <h4>Whats’s Nearby</h4> : ""}
                  <div className="row">
                    {post.nearBy
                      ? post.nearBy.map(near => (
                          <div className="col-md-6 col-6">
                            <div className="row">
                              <div className="col-6">{near.name}</div>
                              <div className="col-6">{near.distance} km</div>
                            </div>
                          </div>
                        ))
                      : ""}
                  </div>
                  <div className="MobileOnly">
                    <div
                      className="ratingBoxPage"
                      style={{ padding: "10px", marginTop: "20px" }}
                    >
                      <div>
                        <h5 style={{ fontSize: "24px", fontWeight: "bold" }}>
                          Need help in choosing the right meeting space?
                        </h5>
                        <div className="row aligner">
                          <div
                            className="col-md-3 col-3"
                            style={{ padding: "0 10px" }}
                          >
                            <img
                              src="https://assets.gofloaters.com/ajay.png"
                              style={{ width: "100%" }}
                            ></img>
                          </div>
                          <div
                            className="col-md-4 col-4"
                            style={{ padding: "0 10px" }}
                          >
                            <p>
                              <b>Ajay</b> <br />
                              <span>Sales Expert</span>
                              <br />
                            </p>
                          </div>
                          <div className="col-md-5 col-5">
                            <a
                              href="https://wame.pro/gofloaters"
                              target="_blank"
                              style={{
                                padding: "10px 15px",
                                color: "#fff",
                                background: "rgb(5,167,81)",
                                borderRadius: "15px",
                                background:
                                  "linear-gradient(90deg, rgba(5,167,81,1) 0%, rgba(124,194,65,1) 50%)",
                                fontSize: "18px",
                                marginTop: "15px",
                                whiteSpace: "nowrap",
                              }}
                              className="meetingConnectWhatsapp"
                            >
                              <i
                                class="fa fa-whatsapp"
                                aria-hidden="true"
                                style={{
                                  fontSize: "20px",
                                  paddingRight: "7px",
                                }}
                              ></i>{" "}
                              Connect
                            </a>
                          </div>

                          <div className="col-md-12 text-center">
                            <hr />
                            <p style={{ fontSize: "16px" }}>
                              Ajay and his team have assisted 120+ clients with
                              meeting space solutions
                            </p>
                            <img
                              src="https://assets.gofloaters.com/clients/newset/chargebee.png"
                              style={{ height: "20px" }}
                            ></img>{" "}
                            <img
                              src="https://assets.gofloaters.com/clients/newset/bira.png"
                              style={{ height: "25px" }}
                            ></img>{" "}
                            <img
                              src="https://assets.gofloaters.com/clients/newset/infeedo.png"
                              style={{ height: "20px" }}
                            ></img>{" "}
                            <img
                              src="https://assets.gofloaters.com/clients/newset/wingify.png"
                              style={{ height: "20px" }}
                            ></img>{" "}
                            <img
                              src="https://assets.gofloaters.com/clients/decalthlon.png"
                              style={{ height: "20px" }}
                            ></img>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {post.spaceDesc ? (
                    <div id="overview" style={{ paddingTop: "30px" }}>
                      <h4>
                        About {post.OriginalName} {post.spaceAddress}
                      </h4>{" "}
                      <VizSensor
                        onChange={() => {
                          setcurrentTab("overview")
                        }}
                      >
                        <p itemprop="description">{post.spaceDesc}</p>
                      </VizSensor>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="row" id="rating">
                    <VizSensor
                      onChange={() => {
                        setcurrentTab("rating")
                      }}
                    >
                      <div className="col-md-8">
                        <br></br>
                        <h4>Space Reviews</h4>
                        <ul className="reviewTab">
                          {post.spaceFeedback.length > 0 ? (
                            <li
                              onClick={() => {
                                setReviewTab("GoFloaters")
                              }}
                              className={reviewTab === "GoFloaters" && "active"}
                            >
                              <p>
                                GoFloaters Review ({post.spaceFeedback.length})
                              </p>
                            </li>
                          ) : (
                            ""
                          )}
                          {post.googleReviewCount > 0 ? (
                            <li
                              onClick={() => {
                                setReviewTab("Google")
                              }}
                              className={reviewTab === "Google" && "active"}
                            >
                              <p>Google Review ({post.googleReviewCount})</p>
                            </li>
                          ) : (
                            ""
                          )}
                        </ul>
                        {reviewTab === "GoFloaters" &&
                        post.spaceFeedback.length > 0 ? (
                          <div>
                            <p className="customerRatingTime">
                              {post.spaceFeedback.length} reviews
                            </p>
                            {post.spaceFeedback.length > 0
                              ? spaceFeedbackComp
                              : "No Review"}
                          </div>
                        ) : (
                          <div>
                            <br />
                            <p style={{ fontSize: "18px" }}>
                              <b style={{ fontSize: "24px", color: "#1e8aa5" }}>
                                {post.googleRating}
                              </b>{" "}
                              Rating from{" "}
                              <b style={{ color: "#1e8aa5" }}>
                                {post.googleReviewCount}
                              </b>{" "}
                              reviews
                            </p>
                            <br />

                            <p>
                              {post.googleMapsLink ? (
                                <a
                                  style={{ fontSize: "18px", color: "#1e8aa5" }}
                                  href={post.googleMapsLink}
                                  target="_blank"
                                >
                                  {" "}
                                  Visit Google Map Review &gt;&gt;
                                </a>
                              ) : (
                                ""
                              )}
                            </p>
                          </div>
                        )}
                      </div>
                    </VizSensor>
                  </div>
                  <br></br>
                  {/* Map through the RandomTestimonials and create the testimonials */}
                  <h4>Happy Customers</h4>
                  <div class="testimonials-container">
                    {testimonialsToShow.map((testimonial, index) => (
                      <div class="testimonial-card first-child">
                        <p class="quote">“</p>
                        <h3>{testimonial.name}</h3>
                        <p>{testimonial.comment}</p>
                      </div>
                    ))}
                  </div>
                  <h4>
                    {post.OriginalName} {post.spaceAddress} FAQ's
                  </h4>
                  <div className="accordion" id="accordionExample">
                    {post.faqs.map((faq, index) => (
                      <div className="accordion-item">
                        <div
                          className="accordion-header"
                          id={"heading_" + index}
                        >
                          <h2 className="mb-0 alignerFaq">
                            <button
                              className="btn btn-link"
                              data-toggle="collapse"
                              data-target={"#collapse_" + index}
                              aria-expanded={index === 0 ? "true" : ""}
                              aria-controls={"collapse_" + index}
                              onClick={() =>
                                index != FAQ ? setFAQ(index) : setFAQ(-1)
                              }
                            >
                              {faq.question}
                            </button>{" "}
                            <i
                              className={
                                FAQ != index
                                  ? "fa fa-chevron-right"
                                  : "fa fa-chevron-down"
                              }
                            ></i>
                          </h2>
                        </div>

                        <div
                          id={"collapse_" + index}
                          className={
                            index === 0
                              ? "accordion-collapse collapse show"
                              : "accordion-collapse collapse"
                          }
                          aria-labelledby="headingOne"
                          data-parent="#accordionExample"
                        >
                          <div className="card-body">{faq.answer}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <br></br>
                  <h4>
                    {post.OriginalName} {post.spaceAddress} Overview
                  </h4>
                  <p
                    className="spaceOverviewtext"
                    dangerouslySetInnerHTML={{ __html: post.spaceOverview }}
                  ></p>
                  <br></br>
                  <AboutLocality
                    city={post.spaceCity}
                    locality={post.spaceAddress}
                  />
                  <br></br>
                  <div className="row">
                    <RelatedSpaces filter={filter} />
                  </div>
                </div>
                <div className="col-md-4 DesktopOnly ">
                  <div className="sticky">
                    {post.avgRating ? (
                      <div className="ratingBoxPage">
                        <p>
                          <div
                            itemprop="aggregateRating"
                            itemscope
                            itemtype="https://schema.org/AggregateRating"
                            className="aggregateRating"
                          >
                            <span style={{ color: "#101010" }}>
                              {" "}
                              {post.avgRating}
                            </span>{" "}
                            <span
                              class={
                                "stars-container stars-" +
                                Number(20) * Number(post.avgRating)
                              }
                            >
                              ★★★★★
                            </span>
                            {"   "}
                            <br />
                            <a onClick={() => scrollTo("#rating")}>
                              See all{" "}
                              <span itemprop="reviewCount">
                                {Number(post.spaceFeedback.length) +
                                  Number(post.googleReviewCount)}
                              </span>{" "}
                              review
                              {post.spaceFeedback.length > 1 ? "s" : ""}
                            </a>
                            <br />
                            <br />
                            <div className="reviewBoxOuter">
                              {Reviews.length > 0 ? (
                                <Carousel
                                  swipeable={true}
                                  draggable={true}
                                  showDots={true}
                                  responsive={responsive}
                                  ssr={true} // means to render carousel on server-side.
                                  autoPlay={false}
                                  autoPlaySpeed={3000}
                                  keyBoardControl={true}
                                  containerClassName="carousel-container"
                                  removeArrowOnDeviceType={["tablet", "mobile"]}
                                  deviceType={props.deviceType}
                                  dotListClassName="custom-dot-list-style"
                                >
                                  {Reviews}
                                </Carousel>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </p>
                      </div>
                    ) : (
                      ""
                    )}

                    {/* <div className="DesktopOnly">
                      <div className="ratingBoxPage" style={{ padding: 0 }}>
                        <VizSensor
                          onChange={() => {
                            setcurrentTab("location")
                          }}
                        >
                          {post.geoLocation !== "" ? (
                            <SimpleMap
                              lat={post.geoLocation[0]}
                              lng={post.geoLocation[1]}
                              height="160px"
                            ></SimpleMap>
                          ) : (
                            "<p></p>"
                          )}
                        </VizSensor>
                      </div>
                    </div> */}

                    <div className="ratingBoxPage ">
                      <div className="priceCloumn row">
                        {post.hourPassAvailable && post.priceHr !== " " ? (
                          <div className="PriceTagnew col-6">
                            <p>
                              {post.priceperhrPreDiscount ? (
                                <b className="priceStrike">
                                  ₹ {post.priceperhrPreDiscount}
                                  <br />
                                </b>
                              ) : (
                                ""
                              )}

                              <b>₹ {post.priceHr}</b>
                              <span>/hour</span>
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                        {post.dayPassAvailable && post.priceDay !== " " ? (
                          <div className="PriceTagnew col-6">
                            <p>
                              {post.priceperdayPreDiscount ? (
                                <b className="priceStrike">
                                  ₹ {post.priceperdayPreDiscount} <br />
                                </b>
                              ) : (
                                ""
                              )}

                              <b>₹ {post.priceDay}</b>
                              <span>/day</span>
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="spaceButtonAlter">
                        {post.online ? (
                          <Link to={"/booking?spaceid=" + post.spaceId}>
                            Book Now
                          </Link>
                        ) : (
                          <a
                            href={
                              "https://www.gofloaters.com/app/#/home/explore/bookingrequest/" +
                              post.spaceId
                            }
                            target="_blank"
                            className="disabled"
                          >
                            Currently unavailable
                          </a>
                        )}
                        <p
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            color: "#878787",
                            paddingTop: "10px",
                          }}
                        >
                          {/* You won’t be charged yet */}
                        </p>
                      </div>
                    </div>

                    <div className="DesktopOnly">
                      <div
                        className="ratingBoxPage"
                        style={{ padding: "10px" }}
                      >
                        <div>
                          <h4>
                            Need help in choosing the right meeting space in{" "}
                            {post.spaceAddress}?
                          </h4>
                          <div className="row aligner">
                            <div
                              className="col-md-3 col-3"
                              style={{ padding: "0 10px" }}
                            >
                              <img
                                src="https://assets.gofloaters.com/ajay.png"
                                style={{ width: "100%" }}
                              ></img>
                            </div>
                            <div
                              className="col-md-4 col-4"
                              style={{ padding: "0 10px" }}
                            >
                              <p>
                                <b>Ajay</b> <br />
                                <span>Sales Expert</span>
                                <br />
                              </p>
                            </div>
                            <div className="col-md-5 col-5">
                              <a
                                href="https://wame.pro/gofloaters"
                                target="_blank"
                                style={{
                                  padding: "10px 15px",
                                  color: "#fff",
                                  background: "rgb(5,167,81)",
                                  borderRadius: "15px",
                                  background:
                                    "linear-gradient(90deg, rgba(5,167,81,1) 0%, rgba(124,194,65,1) 50%)",
                                  fontSize: "18px",
                                  marginTop: "15px",
                                  whiteSpace: "nowrap",
                                }}
                                className="meetingConnectWhatsapp"
                              >
                                <i
                                  class="fa fa-whatsapp"
                                  aria-hidden="true"
                                  style={{
                                    fontSize: "20px",
                                    paddingRight: "7px",
                                  }}
                                ></i>{" "}
                                Connect
                              </a>
                            </div>

                            <div className="col-md-12 text-center">
                              <hr />
                              <p style={{ fontSize: "16px" }}>
                                Ajay and his team have assisted 120+ clients
                                with meeting space solutions
                              </p>
                              <img
                                src="https://assets.gofloaters.com/clients/newset/chargebee.png"
                                style={{ height: "20px" }}
                              ></img>{" "}
                              <img
                                src="https://assets.gofloaters.com/clients/newset/bira.png"
                                style={{ height: "25px" }}
                              ></img>{" "}
                              <img
                                src="https://assets.gofloaters.com/clients/newset/infeedo.png"
                                style={{ height: "20px" }}
                              ></img>{" "}
                              <img
                                src="https://assets.gofloaters.com/clients/newset/wingify.png"
                                style={{ height: "20px" }}
                              ></img>{" "}
                              <img
                                src="https://assets.gofloaters.com/clients/decalthlon.png"
                                style={{ height: "20px" }}
                              ></img>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="MobileOnly FloatButtonBottom">
                <div className="container">
                  <div className="row aligner">
                    <div className="col-6">
                      <div className="PriceTagnew">
                        {post.dayPassAvailable && post.priceDay !== " " ? (
                          <p>
                            {post.priceperdayPreDiscount ? (
                              <b className="priceStrike">
                                ₹ {post.priceperdayPreDiscount} <br />
                              </b>
                            ) : (
                              ""
                            )}
                            <b>₹ {post.priceDay}</b> <span>/ Day</span>
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="PriceTagnew">
                        {post.hourPassAvailable && post.priceHr !== " " ? (
                          <p>
                            {post.priceperhrPreDiscount ? (
                              <b className="priceStrike">
                                ₹ {post.priceperhrPreDiscount} <br />
                              </b>
                            ) : (
                              ""
                            )}
                            <b>₹ {post.priceHr}</b> <span>/ Hour</span>
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-6 text-right">
                      <div className="spaceButtonAlter">
                        {post.online ? (
                          <Link to={"/booking?spaceid=" + post.spaceId}>
                            Book Now
                          </Link>
                        ) : (
                          // <a data-toggle="modal" data-target="#exampleModal">
                          //   Enquire Now
                          // </a>
                          <a
                            href={
                              "https://www.gofloaters.com/app/#/home/explore/bookingrequest/" +
                              post.spaceId
                            }
                            target="_blank"
                            className="disabled"
                          >
                            Currently unavailable
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br></br>

        {/* {post.geoLocation !== "" ? (
          <NearBy
            lat={post.geoLocation[0]}
            lng={post.geoLocation[1]}
            spacetype="meetingSpace"
            exclude={post.spaceId}
          ></NearBy>
        ) : (
          ""
        )} */}
        <div style={{ paddingTop: "100px" }} className="MobileOnly"></div>
      </Layout>
      {/* <div
          className="modal fade show"
          id="exampleModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <EnquiryForm spaceId={post.spaceId} />
          </div>
        </div> */}
    </div>
  )
}

export default MeetingSpaceNew
export const query = graphql`
  query MeetingSpaceNewCR($slug: String!) {
    listings(slug: { eq: $slug }) {
      spaceDisplayName
      OriginalName
      spaceCity
      spaceGFName
      spaceId
      spaceImage
      spaceTitle
      spaceType
      subType
      monthPassAvailable
      officeSpaceType
      priceDay
      priceHr
      priceMonth
      photos
      Facility
      operationTime
      hourPassAvailable
      exclusiveOffer
      dayPassAvailable
      purposesList
      spaceAddress
      noiseLevel
      landmark
      spaceDesc
      hasCovidSafeBadge
      securitydeposit
      seat
      slug
      geoLocation
      spaceOverview
      Rating
      priceperdayPreDiscount
      priceperhrPreDiscount
      googleMapsLink
      googleRating
      googleReviewCount
      avgRating
      meetingRoomName
      buildingSlug
      citySlug
      spaceFeedback {
        customerName
        feedbackDate
        gofloaterrating
        rating
        spaceId
        spaceName
        commentForSpaces
        commentForFloaters
      }
      online
      monday {
        from
        to
        useNow
        holiday
      }
      tuesday {
        from
        to
        useNow
        holiday
      }
      wednesday {
        from
        to
        useNow
        holiday
      }
      thursday {
        from
        to
        useNow
        holiday
      }
      friday {
        from
        to
        useNow
        holiday
      }
      saturday {
        from
        to
        useNow
        holiday
      }
      sunday {
        from
        to
        useNow
        holiday
      }
      nearBy {
        distance
        name
        type
      }
      faqs {
        answer
        question
      }
    }
  }
`
